// @ts-ignore
import config from 'config';

export const clientId = config.api.clientId;
export const authorizationUrl = `${config.api.url}/auth/strava`;
export const tokenUrl = `${config.api.url}/oauth/token`;
export const revokeUrl = `${config.api.url}/oauth/revoke`;
